// src/components/PrivateRoute.tsx
import React, { ReactElement, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import { LoadingComponent } from "../componets/Loading";

interface PrivateRouteProps {
  element: ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const [status, setStatus] = useState<
    "loading" | "unauthenticated" | "blocked" | "allowed"
  >("loading");
  const auth = getAuth();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
      if (!user) {
        setStatus("unauthenticated");
        return;
      }

      try {
        const db = getDatabase();
        const userRef = ref(db, `users/${user.uid}/bloq`);
        const snapshot = await get(userRef);

        if (snapshot.exists() && snapshot.val() === true) {
          console.log("Usuário bloqueado");
          setStatus("blocked");
        } else {
          console.log("Usuário permitido");
          setStatus("allowed");
        }
      } catch (error) {
        console.error("Erro ao verificar bloqueio:", error);
        setStatus("unauthenticated");
      }
    });

    return () => unsubscribe();
  }, [auth]);

  if (status === "loading") {
    return <LoadingComponent />;
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (status === "blocked") {
    return <Navigate to="/sempermissao" />;
  }

  return element;
};

export default PrivateRoute;
